import bowser from 'bowser/bowser.js'
'use strict';

var DyDetection = function () {
  //var self = this;

  var htmlElement = document.querySelector('html');

  // Edge
  if (bowser.msedge) {
    htmlElement.className += ' dy_edge';
  }


  // Explorer
  if (bowser.msie) {
    htmlElement.className += ' dy_iExplorer';
  }

  // Explorer previos to 11
  if (bowser.msie && bowser.version < 11) {
    htmlElement.className += ' dy_iExplorer_old';
  }


  // Mobile
  if (bowser.mobile && !bowser.msie) {
    htmlElement.className += ' dy_mobile';
  } else {
     htmlElement.className += ' dy_noMobile';
  }

  // Tablet
  if (bowser.tablet && !bowser.msie) {
    htmlElement.className += ' dy_tablet';
  } else {
    htmlElement.className += ' dy_noTablet';
  }

  // IOS 7 o inferior
  if (bowser.ios && bowser.version <= 7) {
    htmlElement.className += ' dy_old_ios';
  }

  // IOS
  if (bowser.ios) {
    htmlElement.className += ' dy_ios';
  }



  // Chrome
  if (bowser.chrome) {
    htmlElement.className += ' dy_chrome';
  }

  // Safari
  if (bowser.safari) {
    htmlElement.className += ' dy_safari';
  }

  // Firefox
  if (bowser.firefox) {
    htmlElement.className += ' dy_firefox';
  }

  // Android Device && Android Browser
  if (bowser.android && bowser.name === 'Android') {
    htmlElement.className += ' dy_android_browser';
  }

  // Android Device
  if (bowser.android) {
    htmlElement.className += ' dy_android';
  }

};


DyDetection.prototype.is_mobile_tablet = function () {

  var is_mobile_tablet = false;

  if ((bowser.tablet || bowser.mobile) && !bowser.msie) {
    is_mobile_tablet = true;
  }

  return is_mobile_tablet;

};

DyDetection.prototype.is_mobile = function () {

  var is_mobile = false;

  if (( bowser.mobile) && !bowser.msie) {
    is_mobile = true;
  }

  return is_mobile;

};


DyDetection.prototype.is_tablet = function () {

  var is_tablet = false;

  if ((bowser.tablet) && !bowser.msie) {
    is_tablet = true;
  }

  return is_tablet;

};

DyDetection.prototype.is_desktop = function () {

  var is_desktop = false;

  if ( !(bowser.tablet || bowser.mobile) ) {
    is_desktop = true;
  }

  return is_desktop;

};

window.dyDetection = new DyDetection();


